import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import styles from "../../Table/ReactTableBase.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faDownload,
    faEdit,
    faExternalLink,
    faFemale,
    faLink,
    faLinkSlash,
    faMale,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import {
    getUtilisateurRoleIcon,
    getUtilisateurRoleLabel,
    getUtilisateurStatusIcon,
    parseUtilisateurStatus
} from "../../../services/UserService";
import ReactTableBase from "../../Table/ReactTableBase";
import BtnSwitch from "../../Button/BtnSwitch";
import stylesSwitch from "../../Button/BtnSwitch.module.css";
import {Field, Formik} from "formik";
import stylesField from "../../Field/Field.module.css";
import AxiosConfig from "../../../services/AxiosConfig";
import RenderCellActif from "../../Table/RenderCellActif";
import RenderCellSplit from "../../Table/RenderCellSplit";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";
import TableSearch from "../../Table/TableSearch";
import {filteredDataTabSearch} from "../../../services/UtilsService";

const UtilisateurTable = ({
                              utilisateurs,
                              putActifOpenModal = null,
                              handleSubmitUtilisateurStatus = null,
                              serverSideSorting = false,
                              onSortChange = null,
                              initialSortBy = [],
}) => {
    const [searchQuery, setSearchQuery] = useState("");
    const handleSearch = (event) => { setSearchQuery(event.target.value);};

    const renderFullname = ({ row }) => {
        let myclass = `${styles[row.original.civilite?.label]}`;
        return <span className={myclass} >
            {row.original.civilite.label ? <Link to={Routing.generate({
                route: Routing.routes.adminUtilisateurs,
                queryParams: { filter_civilite: row.original.civilite.id }
            })} className={myclass} title={row.original.civilite.label}>
                {row.original.civilite.label === "madame" ? <FontAwesomeIcon icon={faFemale}/> : <FontAwesomeIcon icon={faMale}/>}
            </Link> : ''}
            <Link to={Routing.generate({
                route: Routing.routes.adminUtilisateur,
                params: { utilisateurId: row.original.id }
            })}>{row.original.nom.toUpperCase()} {row.original.prenom}</Link>
        </span>;
    }

    const renderCellCreated = ({ value }) => {
        return DateService.formatDate(value);
    }

    const renderCellActions = ({ row }) => {
        return (
            <div className={styles.actions}>
                <Link to={Routing.generate({
                    route: Routing.routes.adminUtilisateur,
                    params: { utilisateurId: row.original.id },
                    queryParams: { mode: "creation" }
                })} style={{ marginBottom: "10px", display: "flex", flexDirection: "row" }}>
                    <FontAwesomeIcon icon={faEdit}/>
                    Modifier
                </Link>
                {/* <button onClick={() => console.log("Suppression de l'entreprise", row.original.id)} style={{ backgroundColor: "transparent", fontSize: "1rem" }}><FontAwesomeIcon icon={faXmark}/> Désactiver</button> */}
                <Link  to={Routing.generate({
                    route: Routing.routes.adminUtilisateurStats,
                    params: { utilisateurId: row.original.id },
                })}>
                    <FontAwesomeIcon icon={faExternalLink}/>
                    stats
                </Link>
                <Link to={Routing.generate({
                    route: Routing.routes.adminCrmHistory,
                    queryParams: { filter_user: row.original.id }
                })}>
                    <FontAwesomeIcon icon={faExternalLink}/>CRM Historique
                </Link>
            </div>
        );
    }

    const renderCellEntreprise = ({ row }) => {
        if (row.original?.entreprise === null) return "";
        return <Link to={Routing.generate({
            route: Routing.routes.adminEntreprise,
            params: { entrepriseId: row.original.entreprise?.id }
        })}>{RenderCellSplit({ value: row.original.entreprise?.nom })}</Link>;
    }

    const renderCellRoles = ({ row }) => {
        return row.original.roles.map((role, index) => {
            return <span key={index}>{getUtilisateurRoleIcon(role)} {getUtilisateurRoleLabel(role)}</span>
        });
    }

    const renderCellStatus = ({ value, row }) => {
        return (
            <>
                <Formik
                    initialValues={{ status: value ?? "", id: row.original.id }}
                    onSubmit={handleSubmitUtilisateurStatus}
                    enableReinitialize
                >
                    {({isSubmitting, setFieldValue, values, submitForm}) => {
                        const handleChange = (e) => {
                            const { name, value } = e.target;
                            setFieldValue(name, value, false);
                            submitForm();
                        };

                        return (
                            <div className={styles.selectContainer}>
                                {getUtilisateurStatusIcon(value)}
                                <Field as="select" name="status" onChange={handleChange} className={styles.select}>
                                    <option>
                                        -- Sélectionnez un statut --
                                    </option>
                                    <option value={"-2"}>
                                        En attente de justificatifs
                                    </option>
                                    <option value={"-1"}>
                                        Coach: Attente validation par un Administrateur
                                    </option>
                                    <option value={"0"}>
                                        Importé
                                    </option>
                                    <option value={"1"}>
                                        Compte créé
                                    </option>
                                    <option value={"3"}>
                                        Compte bloqué
                                    </option>
                                </Field>
                            </div>
                        );
                    }
                }
                </Formik>
            </>
        );
    }

    const columns =[
        {
            Header: 'Role',
            accessor: row => row.roles.length > 0 ? row.roles[0] : '',
            Cell: renderCellRoles,
        },
        {
            Header: 'Nom prénom',
            accessor: 'nom',
            Cell: renderFullname,
        },
        {
            Header: 'Entreprise',
            accessor: row => row.entreprise?.nom || '',
            Cell: renderCellEntreprise,
        },
        {
            Header: 'Statut',
            accessor: 'status',
            Cell: renderCellStatus,
            sortType: (rowA, rowB, columnId, desc) => {
                const valA = parseInt(rowA.values[columnId], 10);
                const valB = parseInt(rowB.values[columnId], 10);
                return valA > valB ? 1 : -1;
            },
        },
        {
            Header: 'Crée le',
            accessor: 'date_created',
            Cell: renderCellCreated,
        },
        {
            Header: 'Modifié le',
            accessor: 'date_updated',
            Cell: renderCellCreated,
        },
        {
            Header: 'État',
            accessor: 'actif',
            isBoolean: true,
            Cell: (props) => <RenderCellActif {...props} putActifOpenModal={putActifOpenModal} />,
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: renderCellActions,
        },
    ];

    const filteredData = filteredDataTabSearch(utilisateurs, columns, searchQuery);

    return (
        <>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", margin: "12px 0 12px 0", padding: "0 8px 0 0", width: "100%" }}>
                <TableSearch onSearch={handleSearch} value={searchQuery} />
            </div>

            {/*
                        <ReactTableBase dataSource={utilisateurs} columnsData={columns} />
            */}

            <ReactTableBase dataSource={filteredData} columnsData={columns} serverSideSorting={serverSideSorting}
                            initialSortBy={initialSortBy} onSortChange={onSortChange}/>
        </>
    );
};

export default UtilisateurTable;
